<template>
    <div id="app" class="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'app'
    }
</script>



// WEBPACK FOOTER //
// src/App.vue